import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from "@/common/utils/formatters"
import { GovernmentAllocationDistributionsLimitsData } from "../types/governmentAllocation.type"

export const updateDistributionLimitsDefaultValues = (productCategoryDistributionLimit: GovernmentAllocationDistributionsLimitsData['product_category_distribution_limits'][number]) => {
  return {
    maximum_value: productCategoryDistributionLimit.maximum_value
      ? formatCurrency(Number(productCategoryDistributionLimit.maximum_value))
      : '',
    maximum_quantity: productCategoryDistributionLimit.maximum_quantity
      ? formatDecimalWithGroupedUnit(
        Number(productCategoryDistributionLimit.maximum_quantity),
        productCategoryDistributionLimit.product_distribution_limits,
        (p) => p.product.unit_for_quantity,
      ) : '',
    product_distribution_limits_attributes: productCategoryDistributionLimit.product_distribution_limits.map((productDistributionLimit) => ({
      id: productDistributionLimit.id,
      product: productDistributionLimit.product,
      maximum_value: productDistributionLimit.maximum_value
        ? formatCurrency(Number(productDistributionLimit.maximum_value))
        : '',
      maximum_quantity: productDistributionLimit.maximum_quantity
        ? formatDecimalUnit(Number(productDistributionLimit.maximum_quantity), productDistributionLimit.product.unit_for_quantity)
        : '',
    })),
  }
}
